import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "chevron_66dd4",
  "use": "chevron_66dd4-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"chevron_66dd4\">\n    <path d=\"M163.161 368.211l-120.69-120.69-40.988 40.957 161.679 161.679 347.356-347.356-40.957-40.957z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol